<mat-form-field appearance="fill" class="my-auto w-64">
  <mat-select [formControl]="projectForm">
    @for(project of projects(); track project.id) {
    <mat-option [value]="project.id">
      {{ project.name }}
    </mat-option>
    }
  </mat-select>
</mat-form-field>